import React from 'react';
import { useViewModel } from './hook/use-view-model';
import { SelectItemProps } from './type/props';
import * as styles from './SelectItem.module.sass';
import classNames from 'classnames';

export const SelectItem = (props: SelectItemProps) => {
  const { clickHandler } = useViewModel({
    item: props.item,
    onClick: props.onClick,
  });

  return (
    <div onClick={clickHandler} className={classNames({ [styles.active]: props.isActive }, styles.wrapper)}>
      {props.item.title}
    </div>
  );
};
